import React from 'react';
import { NavLink } from 'react-router-dom';
import { CATEGORIES } from '../data/products';

const CATEGORY_PATHS = {
  todos:      '/',
  mascotas:   '/mascotas',
  hogar:      '/hogar',
  limpieza:   '/limpieza',
  tecnologia: '/tecnologia',
  ofertas:    '/ofertas',
};

const styles = {
  bar: {
    background: 'white',
    borderBottom: '2px solid var(--green-border)',
    overflowX: 'auto',
    scrollbarWidth: 'none',
  },
  inner: {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 20px',
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
  },
};

export default function CategoryBar() {
  return (
    <div style={styles.bar}>
      <div style={styles.inner}>
        {CATEGORIES.map(cat => (
          <NavLink
            key={cat.id}
            to={CATEGORY_PATHS[cat.id]}
            end={cat.id === 'todos'}
            style={({ isActive }) => ({
              display: 'flex',
              alignItems: 'center',
              gap: '7px',
              padding: '14px 18px',
              fontFamily: 'var(--font-main)',
              fontWeight: isActive ? 800 : 600,
              fontSize: '14px',
              color: isActive ? 'var(--green-dark)' : 'var(--gray-600)',
              borderBottom: isActive ? '3px solid var(--green-dark)' : '3px solid transparent',
              transition: 'all 0.2s',
              whiteSpace: 'nowrap',
              marginBottom: '-2px',
              textDecoration: 'none',
              background: 'none',
              cursor: 'pointer',
            })}
            onMouseEnter={e => {
              if (!e.currentTarget.classList.contains('active')) {
                e.currentTarget.style.color = 'var(--green-dark)';
                e.currentTarget.style.background = 'var(--green-pale)';
              }
            }}
            onMouseLeave={e => {
              if (!e.currentTarget.classList.contains('active')) {
                e.currentTarget.style.color = 'var(--gray-600)';
                e.currentTarget.style.background = 'none';
              }
            }}
          >
            <span style={{ fontSize: '16px' }}>{cat.icon}</span>
            {cat.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
